module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAQAAACQTsNJAAABZUlEQVR42tWVS0sCURiGx0uo3UAR9xISSOAtGNCCEIwINSJoEUFUixAqWphalIuQEH3/89NCG/GyOM5E0Tnr88z5vu8571jWv1kkeSftFZJCZL0hIhQRZULujoco84bGe8gzRfzLIeJ0HcBkN1lfpog2YsgVOXYQNjb3CHFnfBtOEGJ/urHUEaJkCnlEtGanQ4AOomGGCNBHXMyPmCpiQNgMMkRcLoBEKVAwbC5txCdxT7KxhxBdUl4gfm7GZjSoudaeIMcMHMlu2cLnDhSjQscBvXLIptsnaCPnTj123UdBnjSNMcj2lCfk6SP6bJgci5Im/e3llGyj0R+YfltkFkAiCHFuAgkzRFQXQFYRombWhybiheAcZBshcmaQEkJUZhobpo3Q6E2ZaP+AEGfERhBCZGihSZkmmITjag/x4Xh7vVRYs0Kd3lRMP5FdMu8ty7LwkeAIcUqStb/9A/4UJOKxlF9dX2BCci1ilkCHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/baseloan/assets/icon-tab-01.png
// module id = fkdB
// module chunks = 70